export default "__VITE_ASSET__CCkCEUD6__"